import React, { useState } from "react";
import { Card, Col, Modal } from "antd";
import { Folder } from "../../redux/interfaces/folder.types.ts";
import { AddTemplatesToFolder } from "../templates/AddTemplatesToFolder.tsx";
import { lightBlue } from "../../utils/theme/colors.ts";

interface Props {
  folder: Folder;
}

export const CardAddTemplates: React.FC<Props> = ({ folder }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const onClosedModal = () => {
    setIsModalVisible(false);
  };

  const onOpenModal = () => {
    setIsModalVisible(true);
  };

  return (
    <div>
      <Modal
        title="Agregar al expediente"
        open={isModalVisible}
        onCancel={onClosedModal}
        footer={null}
      >
        <Card className="w-full">
          <div className="w-full flex justify-center items-center">
            <AddTemplatesToFolder folder={folder} closeModal={onClosedModal} />
          </div>
        </Card>
      </Modal>
      <Col span={8}>
        <div className="cursor-pointer" onClick={onOpenModal}>
          <p style={{ color: lightBlue }} className="font-bold text-justify">
            AGREGAR PLANTILLAS
          </p>
        </div>
      </Col>
    </div>
  );
};
